let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("90VXi")).then(() => parcelRequire('8vVlw'));